import commuterPackage from "./commuterPackage.component";
import commuterPackageUrls from "./commuterPackage.urls";
import CommuterPackageTransforms from "./commuterPackage.transforms";

const commuterPackageModule = angular
  .module("app.components.commuterPackage", [])
  .component("commuterPackagePage", commuterPackage)
  .service("CommuterPackageTransforms", CommuterPackageTransforms)
  .config(commuterPackageUrls);

export default commuterPackageModule;



// WEBPACK FOOTER //
// ./src/pages/commuterPackage/commuterPackage.module.js